import React from 'react';
import Column from '@amzn/meridian/column';
import GrowModelTypeDetermination from './GrowModelTypeDetermination';
import GrowModelActions from './GrowModelActions';

const GrowModel: React.FC = (): React.ReactElement => {
  return (
    <Column>
      <GrowModelTypeDetermination />
      <GrowModelActions />
    </Column>
  );
};

export default GrowModel;
